import script from "./promotionPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./promotionPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__